import { SingleProductViewProps } from 'common/billing//components/Paywall/variants/SingleProductView/types'
import { PaywallDescriptor } from 'common/billing/components/Paywall/interfaces'
import { AiFromTrialProps } from 'common/billing/components/Paywall/variants/AiFromTrial/types'
import { SimpleTrialProps } from 'common/billing/components/Paywall/variants/SimpleTrial/types'
import { CustomUpgradeViewProps } from 'common/billing/components/UpgradeModal/upgradeVariants'
import { UpgradeModalVersion } from 'common/billing/constants'

import { paywalls } from './paywalls'

export const getUpgradeRequestPaywall = (
  variant?: UpgradeModalVersion,
  customProps?: CustomUpgradeViewProps,
  paywallDescriptor?: Nullable<PaywallDescriptor>,
): PaywallDescriptor | null => {
  if (paywallDescriptor) {
    return paywallDescriptor
  }

  switch (variant) {
    case UpgradeModalVersion.UPGRADE_AI:
      return paywalls.upgradeAi(customProps?.[variant] as SingleProductViewProps)
    case UpgradeModalVersion.SIMPLE_TRIAL:
      return paywalls.simpleTrial(customProps?.[variant] as SimpleTrialProps)
    case UpgradeModalVersion.UPGRADE_AI_FROM_TRIAL:
      return paywalls.upgradeAiFromTrial(customProps?.[variant] as AiFromTrialProps)
    case UpgradeModalVersion.CUSTOM:
      return paywalls.custom()
    case UpgradeModalVersion.UNIVERSAL_PAYWALL:
      return paywalls.universal()
    case UpgradeModalVersion.PAYWALL:
      return { variant: UpgradeModalVersion.PAYWALL }
    case UpgradeModalVersion.UPGRADE:
      return { variant: UpgradeModalVersion.UPGRADE }
    default:
      return null
  }
}
